import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !['custompadding', 'customisedFontSize'].includes(prop),
})(({custompadding, customisedFontSize}) => ({
  padding: custompadding || '3px 25px',
  width: '110px',
  fontSize: '13px',
  fontSize:customisedFontSize || '13px',
  borderRadius: '5px',
  color: '#000',
  textTransform: 'none !important',
  marginRight: '20px',
  borderColor: '#D6D8E5',
  fontFamily: 'Figtree-Regular',
  fontWeight: '600',
  letterSpacing: 'normal',
  '&:hover': {
    background: 'none',
    borderColor: '#D6D8E5',
  },
}));

const ModalCancelButton = ({
  label,
  onClickFn,
  customWidth,
  customFontFam,
  custompadding,
  customisedFontSize
}) => {
  const userDomain = useSelector((state) => state?.selectedDomain?.userDomain) || '';

  const buttonStyles = {};

  if (customWidth) {
    buttonStyles.width = `${customWidth}px`;
  }

  if (customFontFam) {
    buttonStyles.fontFamily = customFontFam;
  }

  return (
    <StyledButton
      onClick={onClickFn}
      variant='outlined'
      className={userDomain && !customFontFam && `${userDomain}_font`}
      custompadding={custompadding}
      customisedFontSize={customisedFontSize}
      style={buttonStyles}>
      {label}
    </StyledButton>
  );
};

ModalCancelButton.propTypes = {
  customWidth: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClickFn: PropTypes.func.isRequired,
  customFontFam: PropTypes.string.isRequired,
};

export default ModalCancelButton;
